<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">合约委托管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>止盈止损</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <user-list />
    </el-card>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";

export default {
  name: "ProfitOrder",
  components: {
    UserList,
  },
};
</script>

<style lang="less" scoped></style>
